// extracted by mini-css-extract-plugin
export default {"documentGrid":"orderDocuments_documentGrid__ktcnQ"};